import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors
} from '@angular/forms';
import { ToggleOptions } from './toggle.model';

enum KeyPress {
  Enter = 13
}

@Component({
  selector: 'oir-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleComponent implements OnInit, ControlValueAccessor {
  private _options: ToggleOptions = {
    leftSide: 'No',
    rightSide: 'Yes'
  };

  @Input() set options(value: ToggleOptions) {
    if (value) {
      this._options = value;
    }
  }

  get options(): ToggleOptions {
    return this._options;
  }

  @Input() disabled: boolean;
  @Output() readonly onToggleChange = new EventEmitter<boolean>();
  public form = new FormGroup({
    toggleState: new FormControl(false)
  });

  propagateChange = (_: any) => {};
  propagateTouch = (_: any) => {};

  ngOnInit() {
    this.form.valueChanges.subscribe(val => {
      this.propagateChange(val.toggleState);
      this.onToggleChange.emit(val.toggleState);
    });
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.form.valid ? null : { invalid: true };
  }

  writeValue(obj: boolean | 'true' | 'false'): void {
    if (obj !== null) {
      this.form.patchValue({ toggleState: Boolean(obj) });
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  kDToggleSelected(event): void {
    if (event.which === KeyPress.Enter && !this.disabled) {
      this.toggleSelected();
    }
  }

  toggleSelected(): void {
    this.form.patchValue({ toggleState: !this.form.get('toggleState').value });
  }
}
